window.onload = function() {
  var meta = window.meta || {};

  if (meta && meta.page) {
    if (meta.page.pageType === 'home') {
      ga('send', 'event', 'Homepage', 'View', '', 1);
    } else if (meta.page.pageType === 'page' && document.body) {
      if (document.body.id === 'allerease') {
        ga('send', 'event', 'Category', 'View', 'Allerease', 1);
      } else if (document.body.id === 'sealy') {
        ga('send', 'event', 'Category', 'View', 'Sealy', 1);
      } else if (document.body.id === 'tranquility') {
        ga('send', 'event', 'Category', 'View', 'Tranquilty', 1);
      }
    } else if (meta.page.pageType === 'collection') {
      var pathname = document.location.pathname;
      var name = pathname.substring(pathname.lastIndexOf('/') + 1).replace(/-/g, ' ');

      ga('send', 'event', 'PLP', 'View', name, 1);
    } else if (meta.page.pageType === 'product') {
      var name = $('h1.product-detail__title').text();

      ga('send', 'event', 'PDP', 'View', name, 1);

      $('[data-add-to-cart]').on('click', function() {
        ga('send', 'event', 'PDP', 'Add to Cart', name, 1);
      });
    } else if ($('body').attr('id') === 'your-shopping-cart') {
      var referrerPathName = new URL(document.referrer).pathname;
      var from = '';

      if (referrerPathName === '/') {
        from = 'Homepage';
      } else if (/products/.test(referrerPathName)) {
        from = 'PDP';
      } else if (/collections/.test(referrerPathName)) {
        from = 'PLP';
      } else if (/pages/.test(referrerPathName)) {
        from = 'Category';
      } else {
        from = referrerPathName;
      }
  
      ga('send', 'event', 'Cart', 'View', 'View Cart from ' + from, 1);

      $('.cart-submit').on('click', function() {
        ga('send', 'event', 'Checkout', 'Continue to Checkout', '', 1);
      });

      $('.additional-checkout-buttons').on('click', '[data-testid=GooglePay-button]', function() {
        ga('send', 'event', 'Checkout', 'Express Checkout', 'Google Pay', 1);
      });

      $(document).on('DOMNodeInserted', function(e) {
        var target = e.target;
        var isPaypal = $(target).hasClass('paypal-checkout-sandbox') ||
          $(target).hasClass('paypal-checkout');

        if (isPaypal) {
          ga('send', 'event', 'Checkout', 'Express Checkout', 'PayPal', 1);
        }
      });
    }
  }
}
